import React from 'react'

import { NumberBase } from './NumberBase'

export type IntProps = React.ComponentProps<typeof NumberBase>

export const Int: React.FC<IntProps> = props => <NumberBase {...props} />

export default Int
